const validPasswordStrength = (pw: string) => {
	let criteriaMet = 0;

	// Check for at least one uppercase letter
	if (/[A-Z]/.test(pw)) {
		criteriaMet++;
	}

	// Check for at least one lowercase letter
	if (/[a-z]/.test(pw)) {
		criteriaMet++;
	}

	// Check for at least one digit
	if (/[0-9]/.test(pw)) {
		criteriaMet++;
	}

	// Check for at least one non-alphanumeric character
	if (/[^a-zA-Z0-9]/.test(pw)) {
		criteriaMet++;
	}

	return criteriaMet >= 3 && pw.length >= 8 && pw.length <= 24;
};

export default validPasswordStrength;
